import { getAuth } from "../../contexts/authStore";
import { getAppsyncUrl } from "../authenticate";


export async function putReview(userId: string, dateTime: string, review: number, comment: string, staff: string, name?: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putReview(userId: ${JSON.stringify(userId)}, dateTime: ${JSON.stringify(dateTime)}
                , review: ${JSON.stringify(review)}, comment: ${JSON.stringify(comment)}, staff: ${JSON.stringify(staff)}
                , name: ${JSON.stringify(name)}, approved: ${JSON.stringify(false)}) 
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putReview)
            })
        })
    }
}

export async function getReviews() {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getReviews()
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getReviews)
            })
        })
    }
}

export async function getReview(userId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getReview(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getReview)
            })
        })
    }
}